<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('saleContract.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('saleContract.pageTitle'),
            href: '/admin/sale-contract'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="row">
            <div class="col-md-9">
              <ProductList v-model="model" @calculate="recalculate" />
              <ItemDetail
                v-model="model"
                @loading="value => (loading = value)"
                class="ts-mt-3"
                ref="itemDetail"
              />
            </div>
            <div class="col-md-3 ts-space-y-3">
              <RefDate v-model="model" :validate="errors" />
              <Customer v-model="model" :validate="errors" />

              <div>
                <b-card no-body>
                  <b-card-header
                    header-tag="header"
                    class="card-header pointer-cursor collapsed"
                    aria-expanded="false"
                    v-b-toggle.addBroker
                  >
                    <i
                      class="fas"
                      :class="isBrokerVisible ? 'fa-minus' : 'fa-plus'"
                    ></i>
                    {{ $t('saleContract.addBroker') }}
                  </b-card-header>
                  <b-collapse
                    id="addBroker"
                    visible
                    accordion="addBroker"
                    v-model="isBrokerVisible"
                  >
                    <b-card-body
                      style="
                        padding: 0 0 0 0;
                        background-color: rgba(99, 179, 237, var(--bg-opacity));
                      "
                    >
                      <div>
                        <Broker v-model="model" :validate="errors" />
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>

              <PaymentDate v-model="model" :validate="errors" />
              <ExchangeRate v-model="model" :validate="errors" />
              <DespositPayment
                v-model="model"
                @calculate="recalculate"
                @loading="value => (loading = value)"
                :validate="errors"
              />
              <div>
                <b-card no-body>
                  <b-card-header
                    header-tag="header"
                    class="card-header pointer-cursor collapsed"
                    aria-expanded="false"
                    v-b-toggle.advanceOption
                  >
                    <i
                      class="fas"
                      :class="isVisible ? 'fa-minus' : 'fa-plus'"
                    ></i>
                    {{ $t('saleContract.moreFields') }}
                  </b-card-header>
                  <b-collapse
                    id="advanceOption"
                    visible
                    accordion="advanceOption"
                    v-model="isVisible"
                  >
                    <b-card-body
                      style="
                        padding: 0 0 0 0;
                        background-color: rgba(99, 179, 237, var(--bg-opacity));
                      "
                    >
                      <div>
                        <Status v-model="model" :validate="errors" />
                        <Promotion v-model="model" :validate="errors" />
                        <SaleContractType v-model="model" :validate="errors" />
                        <PreviewOption v-model="model" :validate="errors" />
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </div>
          <div class="row ts-mt-4">
            <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2">
              <ts-button
                @click.prevent="$router.push({ name: 'sale-contract' })"
                >{{ $t('cancel') }}</ts-button
              >
              <ts-button
                :waiting="waiting_preview"
                @click.prevent="saveAddNew"
                color="primary"
                outline
                >{{ $t('savePrint') }}</ts-button
              >
              <ts-button
                :waiting="waiting"
                @click.prevent="onSave"
                color="primary"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
    <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
      <ts-preview-pdf v-model="waiting_preview" :src="src" />
    </a-modal>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import Detail from './components/item-detail.vue'
import RefDate from './components/ref-date.vue'
import Customer from './components/customer.vue'
import PaymentDate from './components/payment-date.vue'
import Status from './components/status.vue'
import ExchangeRate from './components/exchange-rate.vue'
import DespositPayment from './components/desposit-payment.vue'
import ProductList from './components/product-list.vue'
import ItemDetail from './components/item-detail.vue'
import PreviewOption from './components/preview-option.vue'
import Promotion from './components/promotion.vue'
import SaleContractType from './components/sale-contract-type.vue'
import Broker from './components/broker.vue'

export default {
  name: 'quotationCreate',
  components: {
    Detail,
    RefDate,
    Customer,
    PaymentDate,
    Status,
    ExchangeRate,
    DespositPayment,
    ProductList,
    ItemDetail,
    PreviewOption,
    Promotion,
    SaleContractType,
    Broker
  },
  data() {
    return {
      waiting: false,
      waiting_preview: false,
      loading: false,
      show_pdf: false,
      isVisible: false,
      isBrokerVisible: false,
      errors: new Errors(),
      src: null,
      activeKey: [],
      model: {
        contract_date: moment().format('DD-MM-YYYY'),
        project_name: null,
        customer_id: null,
        grand_total: null,
        vat_rate: null,
        vat_amount: null,
        total_exclude_vat: null,
        reference_no: null,
        credit_day: 0,
        payment_expiry_date: moment()
          .add(15, 'days')
          .format('DD-MM-YYYY'),
        expected_delivery_date: moment()
          .add(7, 'days')
          .format('DD-MM-YYYY'),
        kads: null,
        sc_status_id: 3,
        fx_rate_khr: 0,
        fx_rate_thb: 0,
        deposit_amount: 0,
        payment_method_id: 1,
        bank_name: '',
        account_name: null,
        account_number: null,
        exclude_price: false,
        currency: 'USD',
        remark: '',
        item_list: [],
        broker_amount: null,
        promotion_name: null,
        promotion_amount: null,
        sale_type_id: null,
        broker_id: null,
        project_id: null,
        seller_id: null
      }
    }
  },
  created() {
    this.model.vat_rate = parseFloat(
      this.$store.state.authUser.sys_setting.vat_rate
    )
  },
  methods: {
    ...mapActions('wholesale/saleContract', ['getFormViewData', 'store']),
    async fetchData() {
      this.loading = true
      await this.getFormViewData({
        params: undefined,
        index: undefined
      }).finally(() => (this.loading = false))
    },
    saveAddNew() {
      this.waiting_preview = true
      this.show_pdf = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.src = response.url
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.waiting_preview = false
        })
    },
    onSave() {
      this.waiting = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'sale-contract' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    recalculate() {
      this.$refs.itemDetail.calculate()
    },
    clearInput() {
      this.model.contract_date = moment().format('DD-MM-YYYY')
      this.model.project_name = null
      this.model.reference_no = null
      this.model.customer_id = null
      this.model.grand_total = null
      this.model.vat_amount = null
      this.model.total_exclude_vat = null
      this.model.credit_day = 0
      this.model.payment_expiry_date = moment()
        .add(15, 'days')
        .format('DD-MM-YYYY')
      this.model.expected_delivery_date = moment()
        .add(7, 'days')
        .format('DD-MM-YYYY')
      this.model.kads = null
      this.model.sc_status_id = 3
      this.model.fx_rate_khr = 0
      this.model.fx_rate_thb = 0
      this.model.deposit_amount = 0
      this.model.payment_method_id = 1
      this.model.bank_name = ''
      this.model.account_name = null
      this.model.account_number = null
      this.model.item_list = []
      this.model.broker_amount = null
      this.model.promotion_name = null
      this.model.promotion_amount = null
      this.model.sale_type_id = null
      this.model.broker_id = null
      this.model.project_id = null
      this.model.seller_id = null
      this.errors = new Errors()
    }
  },
  beforeRouteLeave(to, from, next) {
    next(vm => {
      vm.$store.commit('wholesale/saleContract/CLEAR_SETUP')
    })
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
<style scoped>
.card-header {
  background-color: #edf2f7;
}
</style>
